<template>
  <div>
    <vue-ueditor-wrap v-if="editorConfig" :config="editorConfig" class="edui-LMS" v-model="content"></vue-ueditor-wrap>
  </div>
</template>

<script>
import mainUrl from '@/http/main_url'
const url = process.env.NODE_ENV === 'development'?'/dev':mainUrl
const EditorConfig = {
    // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 200,
        // 初始容器宽度
        initialFrameWidth: '90%',
        // 元素路径
        elementPathEnabled : false,
        // 启用自动保存
        enableAutoSave: false,
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！部署在国外的服务器，如果无法访问，请自备梯子）
        // serverUrl: 'http://35.201.165.105:8000/controller.php',
        // serverUrl: `${url}/UEditor/jsp/controller.jsp?tenant=sign&name=/data/datafiles/sign/sign/`,
        serverUrl: `${url}/UEditor/jsp/controller.jsp?tenant=sign&name=`,

        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/cedu/UEditor/',
        // UEDITOR_HOME_URL: '/UEditor/',
        toolbars: [
            [
            'source', '|',
            'undo', 'redo', '|',
            'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', '|',
            'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', '|',
            'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|',
            'simpleupload', 'insertimage', "|",
            'attachment', 'fontsize', 'fontfamily'
            // 'removeformat', 'formatmatch','blockquote', ,  '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter'
            ]
        ]
}
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
  name: 'OtsEditor',
  components: { VueUeditorWrap },
  props : {
    value: [String, Number]
  },
  data () {
    return {
      content: '',
      editorConfig: null
    }
  },
  watch: {
    content (newVal) {
      this.$emit('input',newVal)
    },
    value : {
      deep: true,
      immediate: true,
      handler: "setUeditorVal"
    }
  },
  methods: {
    setUeditorVal (newval) {
      this.content = newval
    }
  },
  created() {
    this.mixin_getCommonInfo().then((data) => {
      if (data && data.realPath) {
        EditorConfig.serverUrl = `${url}/UEditor/jsp/controller.jsp?tenant=sign&name=`;
        EditorConfig.serverUrl = EditorConfig.serverUrl + data.realPath
        this.editorConfig = EditorConfig
      }
    })
  }
}
</script>

<style>
@import "./css/ueditor.css";
</style>
